import React, { useState, useEffect } from "react";
import ImportantInfo from "../../atoms/important-updates";
import Navbar from "../../atoms/navbar";
import Footer from "../../atoms/footer";
import { Tabs } from "antd";
import { CarOutlined, UnorderedListOutlined } from "@ant-design/icons";

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../config/api.config";
import ScheduleDriver from "./schedule.booking";
import MyRequests from "./MyRequests";

const DriverMenu = () => {
  
  // Mendapatkan nilai tab aktif dari local storage saat komponen dimuat
  const initialActiveTab = localStorage.getItem("activeTab") || "1";
  const [activeTab, setActiveTab] = useState(initialActiveTab);
  const [userInfo, setUserInfo] = useState(null);
  const [carList, setCarList] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Fungsi untuk menangani perubahan tab
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  async function RequestToken() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    instance
      .acquireTokenSilent(request)
      .then(async (responseToken) => { })
      .catch((e) => {
        console.error(e);
      });
  }

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then((res) => { })
      .catch((e) => {
        console.error(e);
      });
  }

  async function loadUserInfo() {
    try {
      const sessionData = JSON.parse(localStorage.getItem("session_farms"));
      setUserInfo(sessionData);
    } catch (e) {
      console.error('Failed to load user info:', e);
    }
  }

  async function loadCarList() {
    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    try {
      const response = await instance.acquireTokenSilent(request);
      const API = require('../../services').default;
      const HeaderFarms = require('../../utils/header_farms').default;
      const result = await API.ListCar(HeaderFarms(response.accessToken));
      setCarList(result.data || []);
    } catch (e) {
      console.error('Failed to load car list:', e);
    }
  }

  // Menyimpan nilai tab aktif ke local storage setiap kali nilai berubah
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
    if (!isAuthenticated) {
      RequestToken();
    } else {
      if (instance.getAllAccounts().length > 0) {
        instance.setActiveAccount(accounts[0]);
        RequestToken();
        loadUserInfo();
        loadCarList();
      } else {
        handleLogin(instance);
      }
    }
  }, [activeTab, inProgress, accounts, instance, isAuthenticated]);

  return (
    <>
      <Navbar title="Car" back={true} subtitle="" navigate="/home" />
      <div className="container white-back-cr">
        <ImportantInfo />
        <div className="container-fluid" style={{ alignSelf: "center" }}>
          <Tabs
            size="large"
            defaultActiveKey={activeTab}
            onChange={handleTabChange}
          >
            <Tabs.TabPane 
              tab={
                <span>
                  <CarOutlined />
                  Car Schedule
                </span>
              } 
              key="1"
            >
              <ScheduleDriver />
            </Tabs.TabPane>
            <Tabs.TabPane 
              tab={
                <span>
                  <UnorderedListOutlined />
                  My Requests
                </span>
              } 
              key="2"
            >
              <MyRequests 
                instance={instance}
                loginRequest={loginRequest}
                accounts={accounts}
                userInfo={userInfo}
                carList={carList}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DriverMenu;
